module.exports = __webpack_public_path__ + "img/paint-06.6201c778.png";